<label [for]="name()" class="flex w-full flex-col gap-1">
  @if (label()) {
    <span class="font-bold">{{ label() }}</span>
  }
  <div class="flex flex-col">
    <div
      id="input-container"
      [ngClass]="{
        'border-error has-[:focus]:ring-error': isInvalid(),
        'border-theme-secondary-gray has-[:focus]:ring-theme-secondary-gray': !isInvalid(),
        'bg-theme-gray-400 cursor-not-allowed opacity-60': isDisabled(),
      }"
      class="hover:bg-theme-gray-400 has-[:focus]:bg-theme-gray-400 flex w-full gap-2 rounded-[4px] border px-2 py-1 transition has-[:focus]:ring-1">
      <ng-content></ng-content>
      <input
        class="w-full border-none bg-inherit p-0 outline-none focus:ring-0"
        type="text"
        [id]="name()"
        [name]="name()"
        [placeholder]="placeholder()"
        [formControl]="internalControl"
        (click)="clicked.emit()" />
    </div>
  </div>
  @if (isInvalid()) {
    <span class="text-error">{{ warningText() }}</span>
  }
</label>
